import ReactGA from 'react-ga4';

export const eventName = 'BookMeBooking';
export const eventCategory = 'BookMe';
export const eventAction = 'Submit';
export const eventLabel = 'Tenant booked into a viewing';

export default function createBooking(eventArgs = {}) {
  return ReactGA.event(eventName, {
    category: eventCategory,
    action: eventAction,
    label: eventLabel,
    transport: 'xhr',
    ...eventArgs,
  });
}
